import React from 'react';
import { Link, NavLink, Outlet, useLocation } from 'react-router-dom';
import { FaArrowLeft } from 'react-icons/fa';
import { useAuth } from '../../lib/auth.jsx';
import DemoBadge from '../../components/DemoBadge.jsx';
import { useAuth as useRealAuth } from '../../context/AuthContext';

export default function KmLayout() {
  const { logout } = useAuth();
  // 12/10 — l'elenco Esperienze ha dieci colonne (compresa "Uso commerciale"
  // e il tasto di apertura) e con la larghezza standard tagliava le ultime:
  // contenitore allargato solo su questa pagina, spaziatura invariata (stessa
  // scelta fatta in MultiFitting per la vista candidati/annuncio).
  const { pathname } = useLocation();
  const tabellaLarga = /^\/knowledge-management\/esperienze\/?$/.test(pathname);
  // 15/10 — «In scadenza» è una vista HR (matrice §9.2 AF v2.2): la voce di
  // menu si mostra solo a HR e admin. Ruolo vero da /users/me, non il
  // simulatore KM (fissato ad admin dal 28/09); finché il ruolo non è noto
  // la voce resta nascosta, per non farla comparire e sparire.
  const { user: realUser } = useRealAuth();
  const vedeInScadenza = ['hr', 'admin'].includes(realUser?.role);
  return (
    <div className="app-shell km-scope">
      <header className="top-bar">
        <span style={{ display: 'flex', alignItems: 'center', gap: 'var(--space-4)' }}>
          <Link to="/" className="km-back-link">
            <FaArrowLeft size={12} />
            <span>Dashboard</span>
          </Link>
          <span>
            <Link to="/" className="brand">TalentGPT</Link>
            <span className="brand-sub">Knowledge Management</span>
          </span>
        </span>
        <span style={{ display: 'flex', gap: 'var(--space-3)', alignItems: 'center' }}>
          <DemoBadge />
          {/* Selettore ruolo ("Simula ruolo") rimosso il 27/09: chiunque
              accede alla pagina vede tutto, senza distinzione di ruolo. */}
          <button type="button" className="btn-link" onClick={logout}>Esci</button>
        </span>
      </header>

      <nav
        style={{
          display: 'flex',
          gap: 'var(--space-5)',
          padding: '0 var(--space-6)',
          borderBottom: '1px solid var(--color-border)',
          background: 'var(--color-surface)',
        }}
      >
        {[
          { to: '/knowledge-management/esperienze', label: 'Esperienze' },
          { to: '/knowledge-management/ricerca', label: 'Ricerca' },
          ...(vedeInScadenza
            ? [{ to: '/knowledge-management/esperienze-in-scadenza', label: 'In scadenza' }]
            : []),
          // 29/09 — "Editor questionari" nascosto dal menu: non è un
          // requisito dell'AF v2.0 (richiesto solo verbalmente in call),
          // la pagina resta raggiungibile da URL diretto ma non va
          // proposta in navigazione finché non è formalizzato.
        ].map((item) => (
          <NavLink
            key={item.to}
            to={item.to}
            style={({ isActive }) => ({
              padding: 'var(--space-3) 0',
              fontWeight: 600,
              fontSize: 'var(--font-size-sm)',
              color: isActive ? 'var(--color-primary)' : 'var(--color-ink-muted)',
              borderBottom: isActive ? '2px solid var(--color-accent)' : '2px solid transparent',
              textDecoration: 'none',
            })}
          >
            {item.label}
          </NavLink>
        ))}
      </nav>

      <div className={`page-content page-content--wide${tabellaLarga ? ' page-content--table' : ''}`}>
        <Outlet />
      </div>
    </div>
  );
}
